export default {
  zones: (state) => state.zones
}
